import { CurrentTabState } from '../../models/CurrentTabState';
import { createGuid } from 'src/app/core/common';
import { DriveMetadata } from '../services/cloud-storage/metadata/DriveMetadata';
import { DropboxMetaEntryModel } from '../services/cloud-storage/ApiModels/DropboxMetaEntryModel';
import { OneDriveItemMetadata } from '../services/cloud-storage/one-drive/one-drive.api.service';
import { MetadataTypesEnum } from '../services/cloud-storage/enums';

export class AsgardTab {
    id: string;
    isActive: boolean;
    isKES: boolean = false;
    isDediconFile: boolean = false;
    title: string;
    tabStore: CurrentTabState;
    paneIndex: number;
    isSTIFile: boolean = false;

    gDriveMetadata: DriveMetadata | null = null;
    dropboxMetadata: DropboxMetaEntryModel | null = null;
    oneDriveMetadata: OneDriveItemMetadata | null = null;

    file: File;
    password: string | null = null;
    originalFileName: string | null = null;
    isHidden: boolean = false;

    constructor(paneIndex: number, title: string | undefined = undefined, createEditor: boolean = true) {
        this.id = this.generateTabId();
        this.title = title || 'COMMON.NEWTAB';
        this.paneIndex = paneIndex;
        this.tabStore = new CurrentTabState(createEditor);
        this.setActive(this.id);
    }

    get isOriginallyKES(): boolean {
        const result = this.isKES;
        this.isKES = false;
        return result;
    }

    get isDedicon(): boolean {
        return this.isDediconFile;
    }

    get isSTI(): boolean {
        return this.isSTIFile;
    }

    setTabFile(e: File, originalFilename: string | null = null, password: string | null = null, isDediconFile: boolean = false): void {
      // console.log('setTabFile Store: ');
        this.originalFileName = originalFilename;
        this.file = e;
        this.tabStore.changeTabState();
        if (!this.originalFileName) {
            this.originalFileName = this.file.name;
        }
        // console.log(this.tabStore.currentTabState, 'tab state');
        this.password = password;
        this.isDediconFile = isDediconFile;
    }

    unSelectTab(): void {
        this.isActive = false;
    }

    public setActive(id: string): AsgardTab | null {
        if (id === this.id) {
            this.isActive = true;
            this.onTabSelect();
            return this;
        } else {
            this.isActive = false;
            return null;
        }
    }

    public setMetadata(metadata: DriveMetadata | DropboxMetaEntryModel | OneDriveItemMetadata): void {
        switch (metadata.type) {
            case MetadataTypesEnum.DriveMetadata:
                this.gDriveMetadata = metadata as DriveMetadata;
                break;
            case MetadataTypesEnum.DropboxMetaEntryModel:
                this.dropboxMetadata = metadata as DropboxMetaEntryModel;
                break;
            case MetadataTypesEnum.OneDriveMetadata:
                this.oneDriveMetadata = metadata as OneDriveItemMetadata;
                break;
            default: break;
        }
    }

    public destroyTab(): void {
        console.log('destroyTab');
    }

    public setTabTitle(title: string): void {
        this.title = title;
    }

    public onTabSelect(): void {
        // tab was selected update UI state
        this.tabStore.updateUIDependsOnTabState();
    }

    private generateTabId(): string {
        return createGuid();
    }
}
